import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { ReportsService } from "src/app/_Reports/services/reports.service";
import { MasterService } from "src/app/Shared/app.Masters.Service";
import { LmsService } from "../../_Lms/services/lms.service";
import { DataSharingService } from "../../AuthGuard/DataSharingService";
import { EncrDecrService } from "../../AuthGuard/EncrDecrService";
import { constantUrl } from "../../Shared/constantUrl";
import { DialogService } from "../../Shared/dialog.service";
import { SnackbarComponent } from "../../snackbar/snackbar.component";
declare var $: any;

@Component({
  selector: "app-lms-voucher-accounts-view-model",
  templateUrl: "./lms-voucher-accounts-view-model.component.html",
  styleUrls: ["./lms-voucher-accounts-view-model.component.scss"],
  standalone: false
})
export class LmsVoucherAccountsViewModelComponent implements OnInit {
  @Input() voucherid: any;
  @Input() index: any;
  @Input() ROW: any;
  @Input() VoucherFrom: any;
  @Output() close: EventEmitter<any> = new EventEmitter<any>();
  voucherModel: any = { Voucher: {}, Voucher_Detail: [] };
  currentUser: any;
  AccountDocUrl: any = constantUrl.AccountDocUrl;
  displayedLoanColumns: string[] = [
    "Type",
    "CaseNo",
    "Customer",
    "Branch",
    "Category",
    "AccountHead",
    "AmountDR",
    "AmountCR",
  ];
  displayedAccountingColumns: string[] = [
    "AccountHead",
    "Branch",
    "AmountDR",
    "AmountCR",
  ];
  loading: boolean = false;
  ShowEdit: boolean = false;
  ShowDelete: boolean = false;
  ShowAuthorize: boolean = false;
  ShowReject: boolean = false;
  minDate: any;
  docModal: any = [];
  Data_FreezeDate: any;
  Days_Allowed: any;
  Days_AllowedDateMin: any = new Date();
  Days_AllowedDateMax: any = new Date();
  OldData: any = { Voucher: [], Voucher_Detail: [] };
  OldVoucherDate: any;
  oldDocModel: any = { DocumentImages: [] };

  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };

  VoucherPrintModel: any = { Voucher: {}, Voucher_Detail: [] };

  // @Input() VoucherFrom: any;

  BaseUrl: any = constantUrl.apiProfilePicUrl;
  CompanyLogo: any;
  Remark: any;
  AuthorizeRemark: any;
  RejectRemark: any;

  constructor(
    private dataSharingService: DataSharingService,
    public snackBar: MatSnackBar,
    private MasterService: MasterService,
    private ReportsService: ReportsService,

    private router: Router,
    private encdec: EncrDecrService,
    private lmsService: LmsService,
    private dialog: DialogService,
  ) {}

  ngOnInit() {
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
    this.minDate = new Date(this.currentUser.Data_Freeze.split("T")[0]);
    this.CompanyLogo = this.currentUser.CompanyLogo;
  }
  
  onOpenViewDetailModal() {
    this.Days_Allowed = this.currentUser.Days_Allowed;
    this.Data_FreezeDate = new Date(this.currentUser.Data_Freeze.split("T")[0]);
    this.Days_AllowedDateMin.setDate(
      this.Days_AllowedDateMin.getDate() - this.Days_Allowed,
    );
    this.Days_AllowedDateMax.setDate(
      this.Days_AllowedDateMax.getDate() + this.Days_Allowed,
    );

    if (this.Days_AllowedDateMin > this.Data_FreezeDate) {
      this.Days_AllowedDateMin = this.Days_AllowedDateMin;
    } else {
      this.Days_AllowedDateMin = this.Data_FreezeDate;
    }
    this.Days_AllowedDateMax = new Date(
      this.Days_AllowedDateMax.setDate(
        this.Days_AllowedDateMax.getDate() + this.Days_Allowed,
      ),
    );
    this.ReportsService.Get_Voucher_Details_For_UnAuth({
      VoucherId: this.voucherid,
    }).subscribe((res: any) => {
      this.minDate = new Date(
        JSON.parse(sessionStorage.getItem("currentUser")).Data_Freeze.split(
          "T",
        )[0] + " 00:00:00",
      );
      this.voucherModel.Voucher = res.Item1[0];
      var VoucherDate = new Date(
        this.voucherModel.Voucher.VoucherDate.split("T")[0] + " 00:00:00",
      );
      this.voucherModel.Voucher_Detail = res.Item2;
      this.docModal = res.Item3;

      if (
        this.voucherModel.Voucher.Voucher_Status != "Authorized" &&
        this.voucherModel.Voucher.Voucher_Status != "Rejected"
      ) {
        this.ShowAuthorize = true;
        this.ShowReject = true;
      } else {
        this.ShowAuthorize = false;
        this.ShowReject = false;
      }

      this.MasterService.Get_Page_Rights_Of_EMP({
        MMID: "69,196",
        LoginUserId: this.currentUser.userId,
      }).subscribe((result: any) => {
        let AllPage = result;

        this.OldVoucherDate = this.voucherModel.Voucher.Voucher_Date;
        res.Item1.forEach((val) =>
          this.OldData.Voucher.push(Object.assign({}, val)),
        );
        res.Item2.forEach((val) =>
          this.OldData.Voucher_Detail.push(Object.assign({}, val)),
        );
        res.Item3.forEach((val) =>
          this.oldDocModel.DocumentImages.push(Object.assign({}, val)),
        );

        if (result.length > 0) {
          if (
            this.voucherModel.Voucher.Voucher_Type == "Receipt" &&
            AllPage.filter((x) => x.Page_Name == "Voucher Entry - Receipt") !=
              "" &&
            AllPage.filter((x) => x.Page_Name == "Voucher Entry - Receipt") !=
              null
          ) {
            if (
              AllPage.filter((x) => x.Page_Name == "Voucher Entry - Receipt")[0]
                .Edit == 1
            ) {
              if (
                VoucherDate >= this.Days_AllowedDateMin &&
                VoucherDate <= this.Days_AllowedDateMax
              ) {
                this.ShowEdit = true;
              } else {
                this.ShowEdit = false;
              }
            }
            if (
              AllPage.filter((x) => x.Page_Name == "Voucher Entry - Receipt")[0]
                .Delete == 1
            ) {
              if (
                VoucherDate >= this.Days_AllowedDateMin &&
                VoucherDate <= this.Days_AllowedDateMax
              ) {
                this.ShowDelete = true;
              } else {
                this.ShowDelete = false;
              }
            }
          }

          if (
            this.voucherModel.Voucher.Voucher_Type == "Journal" &&
            AllPage.filter((x) => x.Page_Name == "Voucher Entry - Journal") !=
              "" &&
            AllPage.filter((x) => x.Page_Name == "Voucher Entry - Journal") !=
              null
          ) {
            if (
              AllPage.filter((x) => x.Page_Name == "Voucher Entry - Journal")[0]
                .Edit == 1
            ) {
              if (
                VoucherDate >= this.Days_AllowedDateMin &&
                VoucherDate <= this.Days_AllowedDateMax
              ) {
                this.ShowEdit = true;
              } else {
                this.ShowEdit = false;
              }
            }
            if (
              AllPage.filter((x) => x.Page_Name == "Voucher Entry - Journal")[0]
                .Delete == 1
            ) {
              if (
                VoucherDate >= this.Days_AllowedDateMin &&
                VoucherDate <= this.Days_AllowedDateMax
              ) {
                this.ShowDelete = true;
              } else {
                this.ShowDelete = false;
              }
            }
          }

          if (
            this.voucherModel.Voucher.Voucher_Type == "Payment" &&
            AllPage.filter((x) => x.Page_Name == "Voucher Entry - Payment") !=
              "" &&
            AllPage.filter((x) => x.Page_Name == "Voucher Entry - Payment") !=
              null
          ) {
            if (
              AllPage.filter((x) => x.Page_Name == "Voucher Entry - Payment")[0]
                .Edit == 1
            ) {
              if (
                VoucherDate >= this.Days_AllowedDateMin &&
                VoucherDate <= this.Days_AllowedDateMax
              ) {
                this.ShowEdit = true;
              } else {
                this.ShowEdit = false;
              }
            }
            if (
              AllPage.filter((x) => x.Page_Name == "Voucher Entry - Payment")[0]
                .Delete == 1
            ) {
              if (
                VoucherDate >= this.Days_AllowedDateMin &&
                VoucherDate <= this.Days_AllowedDateMax
              ) {
                this.ShowDelete = true;
              } else {
                this.ShowDelete = false;
              }
            }
          }

          if (
            this.voucherModel.Voucher.Voucher_Type == "Contra" &&
            AllPage.filter((x) => x.Page_Name == "Voucher Entry - Contra") !=
              "" &&
            AllPage.filter((x) => x.Page_Name == "Voucher Entry - Contra") !=
              null
          ) {
            if (
              AllPage.filter((x) => x.Page_Name == "Voucher Entry - Contra")[0]
                .Edit == 1
            ) {
              if (
                VoucherDate >= this.Days_AllowedDateMin &&
                VoucherDate <= this.Days_AllowedDateMax
              ) {
                this.ShowEdit = true;
              } else {
                this.ShowEdit = false;
              }
            }
            if (
              AllPage.filter((x) => x.Page_Name == "Voucher Entry - Contra")[0]
                .Delete == 1
            ) {
              if (
                VoucherDate >= this.Days_AllowedDateMin &&
                VoucherDate <= this.Days_AllowedDateMax
              ) {
                this.ShowDelete = true;
              } else {
                this.ShowDelete = false;
              }
            }
          }
        } else {
          if (this.voucherModel.Voucher.Voucher_No.substring(0, 2) == "SL") {
            this.ShowEdit = false;
          }
        }
      });

      if (new Date(this.voucherModel.Voucher.Voucher_Date) < this.minDate) {
        this.ShowEdit = false;
        this.ShowDelete = false;
      }
      this.voucherModel.Voucher_Detail.forEach((x) => {
        x.AmountDR = 0.0;
        x.AmountCR = 0.0;
        if (x.TranType == "CR") x.AmountCR = x.Amount;
        if (x.TranType == "DR") x.AmountDR = x.Amount;
      });
      this.onVoucherTagChange();
      this.VoucherPrintModel = {
        Voucher: this.voucherModel.Voucher,
        Voucher_Detail: this.voucherModel.Voucher_Detail,
      };
      $(`.VoucherAccountDetail${this.index}`).modal("show");
      $(`.VoucherAccountDetail${this.index}`).css("z-index", "1050");
    });
    console.log("VoucherFrom", this.VoucherFrom);

  }

  onVoucherTagChange() {
    this.Get_Acc_Accounts_By_Tag();
  }
  Get_Acc_Accounts_By_Tag() {
    this.voucherModel.Voucher.DRAccountId = "";
    if (this.voucherModel.Voucher.Voucher_Tag == null)
      this.voucherModel.Voucher.Voucher_Tag = "CASH";
    this.lmsService
      .Get_Acc_Accounts_By_Tag({
        Account_Tag: this.voucherModel.Voucher.Voucher_Tag,
        Voucher_Date: new Date(this.voucherModel.Voucher.Voucher_Date),
      })
      .subscribe((res: any) => {});
  }

  OnClose() {
    $(`.VoucherAccountDetail${this.index}`).modal("hide");
    var data = { status: true, ROW: this.ROW };
    this.close.emit(data);
  }

  GetData(data) {
    if (data == true) {
      this.OnClose();
      var data1 = { status: true, ROW: this.ROW };
      this.close.emit(data1);
    }
  }

  exportTable(exporter: any) {
    exporter.exportTable("xls", {
      fileName: "Accounting Statement",
      sheet: "Accounting Statement",
    });
  }

  calculateTranTypeCR() {
    if (this.voucherModel.Voucher_Detail != null) {
      let sum = 0.0;
      for (let i = 0; i < this.voucherModel.Voucher_Detail.length; i++) {
        sum += Number(this.voucherModel.Voucher_Detail[i]["AmountCR"]);
      }
      return sum.toFixed(2);
    }
    return 0;
  }
  calculateTranTypeDR() {
    if (this.voucherModel.Voucher_Detail != null) {
      let sum = 0.0;
      for (let i = 0; i < this.voucherModel.Voucher_Detail.length; i++) {
        sum += Number(this.voucherModel.Voucher_Detail[i]["AmountDR"]);
      }
      return sum.toFixed(2);
    }
    return 0;
  }
  ConfirmDelete(voucherId: number) {
    const id = this.voucherModel?.Voucher?.VoucherId;
    $("#DeleteRemarkModalAccounts").data("voucherId", id).modal("show");
    $("#DeleteRemarkModalAccounts").css("z-index", "999999");

  }

  DeleteVoucher() {
    const DeleteVoucherId = $("#DeleteRemarkModalAccounts").data("voucherId");
    if (!this.Remark || this.Remark.trim() === "") {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Remark is required.",
        ...this.configSuccess,
      });
      return;
    } else {
      $("#DeleteRemarkModalAccounts").modal("hide");
      // var FinalOldData = {
      //   Voucher: this.dataSharingService.cleanObject({
      //     ...this.OldData.Voucher[0],
      //   }),
      //   Voucher_Detail: this.OldData.Voucher_Detail,
      //   Voucher_Attachment: this.oldDocModel.DocumentImages,
      // };
      this.ReportsService
        .Delete_Unauth_ACC_Voucher({
          VoucherId: DeleteVoucherId,
          LoginUserId: this.currentUser.userId,
          Remark: this.Remark,
        })
        .subscribe((res: any) => {
          if (res[0].CODE == 0) {
            this.snackBar.openFromComponent(SnackbarComponent, {
              data: res[0].MSG,
              ...this.configSuccess,
            });
            // this.lmsService
            //   .Acc_Voucher_Audit_Trail_Delete({
            //     VoucherId: DeleteVoucherId,
            //     Modify_By: this.currentUser.userId,
            //     Type: "Delete",
            //     JSON: JSON.stringify(FinalOldData),
            //   })
            //   .subscribe((res: any) => {});
            // this.snackBar.openFromComponent(SnackbarComponent, {
            //   data: res[0].MSG,
            //   ...this.configSuccess,
            // });
            if (
              this.voucherModel.Voucher_Detail.find((obj: any) => {
                return obj.ChargeHeadId == 34;
              })
            )
              this.lmsService
                .LMS_Update_EMI_Allocation({ VoucherId: DeleteVoucherId })
                .subscribe((res1: any) => {});
            this.OnClose();
          }
        });
    }
  }
  CloseDeleteRemarkModal() {
    this.Remark = "";
    $(`#DeleteRemarkModalAccounts`).modal("hide");
  }

  ConfirmAuthorize() {
    const id = this.voucherModel?.Voucher?.VoucherId;
    $("#AuthorizeRemarkModalAccounts").data("voucherId", id).modal("show");
    $("#AuthorizeRemarkModalAccounts").css("z-index", "1000050");
  }


  AuthorizeVoucher() {
    const AuthorizeVoucherId = $("#AuthorizeRemarkModalAccounts").data(
      "voucherId",
    );
    if (!this.AuthorizeRemark || this.AuthorizeRemark.trim() === "") {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Remark is required.",
        ...this.configSuccess,
      });
      return;
    } else {
      this.loading = true;
      $("#AuthorizeRemarkModalAccounts").modal("hide");
      const requestPayload = {
        Status: "Authorized",
        VoucherIds: AuthorizeVoucherId.toString(),
        LoginUserId: this.currentUser.userId,
        Remark: this.AuthorizeRemark,
      };
      this.ReportsService.Save_Voucher_Authorized_Or_Reject(
        requestPayload,
      ).subscribe((res: any) => {
        this.loading = false;
        if (res[0].CODE >= 0) {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: res[0].MSG,
            ...this.configSuccess,
          });
          this.OnClose();
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: res[0].MSG,
            ...this.configSuccess,
          });
        }
      });
    }
  }

  CloseAuthorizeRemarkModal() {
    this.AuthorizeRemark = "";
    $(`#AuthorizeRemarkModalAccounts`).modal("hide");
  }

  ConfirmReject() {
    const id = this.voucherModel?.Voucher?.VoucherId;
    $("#RejectRemarkModalAccounts").data("voucherId", id).modal("show");
    $("#RejectRemarkModalAccounts").css("z-index", "1000050");
  }


  RejectVoucher() {
    const RejectVoucherId = $("#RejectRemarkModalAccounts").data("voucherId");
    if (!this.RejectRemark || this.RejectRemark.trim() === "") {
      this.snackBar.openFromComponent(SnackbarComponent, {
        data: "Remark is required.",
        ...this.configSuccess,
      });
      return;
    } else {
      this.loading = true;
      $("#RejectRemarkModalAccounts").modal("hide");
      const requestPayload = {
        Status: "Rejected",
        VoucherIds: RejectVoucherId.toString(),
        LoginUserId: this.currentUser.userId,
        Remark: this.RejectRemark,
      };
      this.ReportsService.Save_Voucher_Authorized_Or_Reject(
        requestPayload,
      ).subscribe((res: any) => {
        this.loading = false;
        if (res[0].CODE >= 0) {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: res[0].MSG,
            ...this.configSuccess,
          });
          this.OnClose();
        } else {
          this.snackBar.openFromComponent(SnackbarComponent, {
            data: res[0].MSG,
            ...this.configSuccess,
          });
        }
      });
    }
  }

  CloseRejectRemarkModal() {
    this.RejectRemark = "";
    $(`#RejectRemarkModalAccounts`).modal("hide");
  }
}
